import * as Dialog from '@radix-ui/react-dialog';
import { Close } from '@/assets/icons';
import React from 'react';
import { ButtonSize } from '../Button';
import { ModalTheme } from './types';
import { defaultModalTheme } from './modalTheme';

interface ModalProps {
  visible: boolean;
  onSetVisible: (open: boolean) => void;
  title?: string | React.ReactNode;
  children?: React.ReactNode;
  actions?: ActionProps[];
  className?: string;
  showCloseButton?: boolean;
  theme?: ModalTheme;
  disableCloseOutside?: boolean;
}

export interface ActionProps {
  title?: string;
  buttonStyle?: string;
  size?: ButtonSize;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const Modal: React.FC<ModalProps> = ({
  visible,
  onSetVisible,
  title,
  children,
  actions,
  className,
  theme = defaultModalTheme,
  showCloseButton,
  disableCloseOutside,
}) => (
  <Dialog.Root open={visible} onOpenChange={onSetVisible}>
    <Dialog.Portal>
      <Dialog.Overlay className={`fixed inset-0 z-10 ${theme.overlay}`}>
        <Dialog.Content
          className="fixed inset-0 z-10 overflow-y-auto"
          onInteractOutside={e => disableCloseOutside && e.preventDefault()}
          onEscapeKeyDown={e => disableCloseOutside && e.preventDefault()}
        >
          <div className={theme.container}>
            <div className={`${theme.content} ${className}`}>
              <div className={theme.header}>
                {(showCloseButton === undefined || showCloseButton === true) && (
                  <div className="self-end">
                    <Dialog.Close>
                      <img src={Close} alt="button closer" />
                    </Dialog.Close>
                  </div>
                )}

                {title && <div className={theme.title}>{title}</div>}
              </div>
              {children}
              {actions && (
                <div>
                  {actions.map((action: ActionProps, index: number) => (
                    <button key={index}>{action.title}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Overlay>
    </Dialog.Portal>
  </Dialog.Root>
);

export const ShowModal: React.FC<ModalProps> = ({
  visible,
  onSetVisible,
  title,
  children,
  actions,
}) => (
  <Modal visible={visible} onSetVisible={onSetVisible} title={title} actions={actions}>
    {children}
  </Modal>
);
